import type { ConversationItem, ConversationDetail, MessageItem, CustomerDto } from '@/types';

export const MOCK_CONVERSATION_ID = 'mock_sample_conversation';

export const MOCK_CONVERSATION_ITEM: ConversationItem = {
  id: MOCK_CONVERSATION_ID,
  storeId: 'store_mock_nuvemshop',
  storeName: 'Sua Loja Nuvemshop',
  customerId: 'cust_mock_123',
  customerName: 'Camila Silva (Exemplo)',
  customerEmail: 'camila.silva@exemplo.com',
  customerPhone: '(11) 98765-4321',
  title: 'Dúvida sobre prazo de entrega',
  status: 'Active',
  unreadCount: 0,
  createdAtUtc: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
  updatedAtUtc: new Date().toISOString(),
  lastMessage: {
    id: 'mock_msg_4',
    content: 'Sim! Pedidos aprovados até as 14h são postados no mesmo dia útil.',
    senderType: 'AI',
    senderName: 'Assistente IA',
    createdAtUtc: new Date(Date.now() - 1000 * 60 * 1).toISOString(),
  },
};

export const MOCK_MESSAGES: MessageItem[] = [
  {
    id: 'mock_msg_1',
    conversationId: MOCK_CONVERSATION_ID,
    content: 'Olá! Gostaria de saber qual é o prazo de entrega para o CEP 01310-100?',
    senderType: 'Customer',
    guestName: 'Camila Silva',
    createdAt: new Date(Date.now() - 1000 * 60 * 5).toISOString(),
  },
  {
    id: 'mock_msg_2',
    conversationId: MOCK_CONVERSATION_ID,
    content: 'Olá, Camila! Para o CEP informado (São Paulo - SP), o prazo de entrega é de 2 a 4 dias úteis via Sedex ou até 6 dias úteis via PAC.',
    senderType: 'AI',
    createdAt: new Date(Date.now() - 1000 * 60 * 4).toISOString(),
  },
  {
    id: 'mock_msg_3',
    conversationId: MOCK_CONVERSATION_ID,
    content: 'Perfeito! Se eu finalizar a compra agora, vocês despacham hoje mesmo?',
    senderType: 'Customer',
    guestName: 'Camila Silva',
    createdAt: new Date(Date.now() - 1000 * 60 * 2).toISOString(),
  },
  {
    id: 'mock_msg_4',
    conversationId: MOCK_CONVERSATION_ID,
    content: 'Sim! Pedidos aprovados até as 14h são postados no mesmo dia útil. Qualquer dúvida adicional, estou à disposição!',
    senderType: 'AI',
    createdAt: new Date(Date.now() - 1000 * 60 * 1).toISOString(),
  },
];

export const MOCK_CONVERSATION_DETAIL: ConversationDetail = {
  ...MOCK_CONVERSATION_ITEM,
  messages: MOCK_MESSAGES,
};

export const MOCK_CUSTOMER_DTO: CustomerDto = {
  id: 'cust_mock_123',
  storeId: 'store_mock_nuvemshop',
  name: 'Camila Silva (Exemplo)',
  email: 'camila.silva@exemplo.com',
  phone: '(11) 98765-4321',
  firstSeenAtUtc: new Date(Date.now() - 1000 * 60 * 60 * 24 * 7).toISOString(),
  lastSeenAtUtc: new Date().toISOString(),
  totalConversations: 1,
};
